import { type LucideProps, Moon, SunMedium } from 'lucide-react';
import React, { forwardRef } from 'react';

const IconEmbiraMark = forwardRef<SVGSVGElement, LucideProps>(
  function IconEmbiraMark(props, ref) {
    return (
      <svg
        id="embira_mark"
        data-name="embira mark"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 69.35 78.03"
        ref={ref}
        {...props}
      >
        <polygon
          points="0 52.03 0 60.7 34.68 78.03 69.35 60.7 69.35 52.03 34.68 69.36 0 52.03"
          fill="currentColor"
        />
        <polygon
          points="34.68 0 0 17.34 0 17.35 0 43.34 34.68 60.68 69.35 43.34 69.35 34.68 34.68 52.01 34.68 43.36 69.35 26.02 69.35 26.01 69.35 17.35 69.35 17.34 34.68 0"
          fill="currentColor"
        />
      </svg>
    );
  }
);

const IconEmbiraLogo = forwardRef<SVGSVGElement, LucideProps>(
  function IconEmbiraLogo(props, ref) {
    return (
      <svg
        id="embira_logo"
        data-name="embira logo"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 106.64 23.49"
        ref={ref}
        {...props}
      >
        <path
          d="M40.67,5.86c-.91-.54-1.99-.81-3.24-.81s-2.33.28-3.25.83c-.92.55-1.63,1.34-2.14,2.35-.51,1.02-.76,2.21-.76,3.6h0c0,1.4.25,2.59.76,3.6.51,1.01,1.23,1.79,2.17,2.34.94.55,2.06.82,3.37.82.92,0,1.71-.12,2.39-.36.68-.24,1.26-.57,1.73-.97.47-.4.85-.85,1.13-1.33.28-.49.47-.97.56-1.44l.04-.13h-3.2l-.02.07c-.08.24-.23.48-.45.72s-.51.43-.86.58c-.35.15-.76.23-1.24.23-.6,0-1.13-.14-1.56-.41-.44-.27-.77-.66-1.01-1.17-.22-.48-.33-1.05-.34-1.7h8.8v-1.1c0-1.31-.25-2.45-.75-3.43-.5-.98-1.2-1.74-2.11-2.27ZM36.05,8.1c.42-.27.9-.4,1.44-.4s1.02.13,1.43.39c.41.26.73.65.96,1.16.15.34.23.74.29,1.18h-5.38c.05-.43.14-.83.29-1.16.23-.51.56-.9.98-1.17Z"
          fill="currentColor"
        />
        <path
          d="M62.22,5.6c-.63-.36-1.36-.55-2.2-.55-.63,0-1.21.11-1.74.33-.53.22-.99.53-1.37.93s-.67.88-.87,1.43h-.07c-.14-.57-.37-1.06-.7-1.46-.33-.4-.73-.7-1.21-.91-.48-.21-1.02-.32-1.61-.32-.86,0-1.61.22-2.24.67s-1.08,1.04-1.34,1.78h-.07v-2.18h-3.49v13h3.49v-7.85c0-.48.09-.91.28-1.29s.45-.67.78-.88c.33-.21.72-.32,1.16-.32s.8.09,1.1.27.54.43.71.76.25.73.25,1.2v8.1h3.35v-7.9c0-.49.09-.91.27-1.27.18-.36.44-.65.77-.85.33-.21.71-.31,1.15-.31s.83.09,1.14.27c.31.18.54.44.7.79s.24.77.24,1.28v7.99h3.49v-8.89c0-.88-.18-1.65-.53-2.31-.35-.65-.84-1.16-1.47-1.53Z"
          fill="currentColor"
        />
        <path
          d="M76.8,5.86c-.78-.54-1.7-.81-2.78-.81-.6,0-1.16.1-1.68.3-.51.2-.96.49-1.34.87-.38.38-.69.83-.93,1.35h-.07V.82h-3.49v17.51h3.49v-2.22h.07c.23.52.54.96.92,1.33.38.37.83.66,1.34.86.51.2,1.07.3,1.68.3,1.07,0,2-.27,2.78-.81.78-.54,1.38-1.32,1.8-2.33.42-1.01.63-2.22.63-3.63h0c0-1.43-.21-2.64-.63-3.65-.42-1.01-1.02-1.78-1.8-2.32ZM75.67,11.82c0,.78-.11,1.46-.34,2.04-.23.57-.55,1.02-.97,1.33-.42.31-.92.47-1.5.47s-1.06-.16-1.49-.47c-.43-.31-.76-.75-1-1.33s-.36-1.25-.36-2.04h0c0-.79.12-1.46.36-2.04.24-.57.58-1.02,1-1.33s.92-.47,1.49-.47,1.07.15,1.49.46c.42.31.75.75.98,1.32s.35,1.25.35,2.04h0Z"
          fill="currentColor"
        />
        <path
          d="M82.83-.04c-.52,0-.97.18-1.33.54-.36.36-.54.79-.54,1.3s.18.94.54,1.3c.36.37.81.55,1.33.55s.97-.18,1.33-.55c.36-.37.54-.8.54-1.3s-.18-.94-.54-1.3c-.36-.36-.8-.54-1.33-.54Z"
          fill="currentColor"
        />
        <rect x="81.08" y="5.32" width="3.5" height="13" fill="currentColor" />
        <path
          d="M93.37,5.06c-.75,0-1.37.22-1.87.67-.5.44-.85,1.07-1.04,1.87h-.07v-2.27h-3.49v13h3.49v-7.28c0-.63.11-1.16.32-1.6.21-.44.53-.77.93-1,.41-.23.9-.34,1.47-.34.25,0,.49.02.72.05.22.04.41.09.55.15v-3.13c-.13-.04-.28-.07-.45-.1-.18-.02-.36-.04-.55-.04Z"
          fill="currentColor"
        />
        <path
          d="M105.96,7.12c-.45-.65-1.08-1.16-1.89-1.52-.81-.36-1.77-.54-2.88-.54s-2.09.18-2.91.53c-.82.35-1.45.84-1.91,1.46-.46.62-.72,1.33-.79,2.14v.15s3.19,0,3.19,0l.02-.11c.09-.42.32-.77.7-1.04.38-.27.9-.41,1.55-.41s1.21.17,1.56.5c.36.33.54.78.54,1.36v.8l-3.16.2c-1.06.07-1.96.27-2.7.59-.74.32-1.31.77-1.7,1.33-.39.56-.58,1.24-.58,2.03v.02c0,.76.18,1.44.54,2.03.36.59.87,1.06,1.52,1.4.65.34,1.4.5,2.25.5.56,0,1.08-.08,1.56-.25.48-.17.91-.42,1.28-.74.37-.32.68-.7.93-1.14h.07v1.93h3.49v-8.92c0-.87-.23-1.64-.67-2.29ZM102.8,14.79c-.23.36-.56.64-.97.85-.41.21-.87.31-1.39.31-.6,0-1.09-.14-1.44-.41s-.54-.65-.54-1.12v-.02c0-.46.17-.83.53-1.1.35-.27.86-.43,1.53-.47l2.64-.18v.94c0,.44-.12.85-.35,1.21Z"
          fill="currentColor"
        />
        <g>
          <polygon
            points="0 15.68 0 18.28 10.42 23.49 20.84 18.28 20.84 15.68 10.42 20.89 0 15.68"
            fill="currentColor"
          />
          <polygon
            points="10.42 .04 0 5.25 0 5.25 0 13.07 10.42 18.28 20.84 13.07 20.84 10.46 10.42 15.67 10.42 13.07 20.84 7.86 20.84 7.86 20.84 5.25 20.84 5.25 10.42 .04"
            fill="currentColor"
          />
        </g>
      </svg>
    );
  }
);

export const Icons = {
  sun: SunMedium,
  moon: Moon,
  mark: IconEmbiraMark,
  logo: IconEmbiraLogo,
};
